import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const auditLogApiKeyStore = {
  generateAuditLogWithPagination: (): MutationKeyConfig => ({
    mutationKey: [`GENERATE_Audit_Log`],
    route: `/Audit/Logs`,
    action: 'POST',
    disableSnackbar: true,
  }),
  exportAuditExcel: (): MutationKeyConfig => ({
    mutationKey: [`EXPORT_AUDIT_EXCEL`],
    route: `/Export/AuditLog`,
    action: 'POST',
    disableSnackbar: true,
  }),
};
